/**
 * Utility functions for color manipulation and detection
 */

/**
 * Calcula a luminância relativa de uma cor hexadecimal
 * usando a fórmula WCAG 2.0
 * @param {string} hex - Cor em formato hexadecimal (#RRGGBB)
 * @returns {boolean} true se a cor é escura (luminância < 0.4)
 */
export function isDarkColor(hex) {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  
  const toLinear = (c) => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  
  const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
  
  return luminance < 0.4;
}

/**
 * Verifica se a cor é "muito escura" (praticamente preta)
 * @param {string} hex - Cor em formato hexadecimal (#RRGGBB)
 * @returns {boolean} true se a luminância é muito baixa (< 0.05)
 */
export function isVeryDarkColor(hex) {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  
  const toLinear = (c) => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  
  const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
  
  return luminance < 0.05;
}
